import DealWallComponent from "@/components/deal-detail/data-lake/deal-wall";
import type { DealTransformed } from "@/lib/schema/deal-schema";
import { memo } from "react";

interface NotesTabProps {
  currentDeal: DealTransformed;
}

function NotesTab({ currentDeal }: NotesTabProps) {
  return (
    <div className="mx-auto max-w-3xl p-6">
      <DealWallComponent deal={currentDeal} />
    </div>
  );
}

export default memo(NotesTab);
